import React from 'react'
import {
  Modal,
  ModalInjectedProps,
  Text,
  Link,
  Button,
} from '@sketch/components'
import { Strong } from './PlanOverviewPanel.styles'
import { SKETCH_WEBSITE } from '@sketch/env-config'

const PriceIncreaseModal = ({ hideModal }: ModalInjectedProps) => (
  <Modal onCancel={hideModal}>
    <Modal.Header>
      <Text fontWeight="bold">Why We’re changing Our Pricing</Text>
    </Modal.Header>
    <Modal.Body>
      <Text pt={3}>
        In recent years, we’ve worked hard to evolve Sketch into a complete
        design platform. Among our{' '}
        <Link
          variant="primary"
          href={`${SKETCH_WEBSITE}/updates/`}
          isUnderlined
          external
        >
          regular updates
        </Link>
        , we’ve introduced real-time collaboration, Workspaces, annotations,
        developer handoff, Prototyping, and more.
      </Text>
      <Text>
        For the first time in seven years, we’re introducing a modest increase
        to our prices. Here’s how things will change with your next bill from{' '}
        <Strong>19 May 2023</Strong> onwards:
      </Text>
      <Text>
        — Monthly subscriptions will increase from <Strong>$9 to $12</Strong>{' '}
        per month per Editor <br />— Yearly subscriptions will increase from{' '}
        <Strong>$99 to $120</Strong> per year per Editor
      </Text>
      <Text>
        Even with these increases, you’ll find our pricing is still favorable
        compared to our competitors. We’ve also doubled the discount for yearly
        plans (from one free month to two, <Strong>saving you $24)</Strong> —
        <Link
          variant="primary"
          href={`${SKETCH_WEBSITE}/support/contact/`}
          isUnderlined
          external
        >
          get in touch
        </Link>{' '}
        with us if you’d like to switch to that on or after 19 May.
      </Text>
      <Text fontWeight="bold">Why are We Increasing Prices?</Text>
      <Text>
        We don’t take decisions like these lightly, but like everyone else, our
        running costs are increasing. This helps us remain sustainable and
        deliver more new features and improvements.
      </Text>
      <Text>
        If you decide these new prices aren’t for you (and we’d hate to say
        goodbye), you can cancel your subscription via your Workspace Settings
        at any time.
      </Text>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={hideModal}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
)

export { PriceIncreaseModal }
